import { createFileRoute } from '@tanstack/react-router'
import { AlternativesPage, alternativesHead, type AlternativesData } from '@/components/alternatives-page'
import { MONITOR_LOCATIONS } from '@/lib/check-locations'

const data: AlternativesData = {
  tool: "Hyperping",
  slug: "hyperping",
  intro: "Hyperping starts 30-second checks at $24/mo and sells extra seats per user. If you want a lower price or a different feature mix, these alternatives are worth comparing.",
  alternatives: [
    {
      name: "Better Stack",
      description: "Uptime monitoring combined with on-call, incident management, logs, and status pages in one platform.",
      pricing: "Free (10 monitors), paid from $34/mo per responder",
      pros: ["On-call scheduling and incident management", "Unlimited phone and SMS alerts on paid plans", "Multi-location confirmation (3 of 4 locations by default)"],
      cons: ["Priced per responder, plus monitor packs", "More product than you need if you only want uptime checks"],
      url: "https://betterstack.com",
    },
    {
      name: "Uptrack",
      description: "Uptime monitoring with 30-second checks on every plan, alert confirmation, and browser checks. Pro is $3/mo for 50 monitors.",
      pricing: "Free (5 monitors), Pro $3/mo, Team $20/mo, Business $79/mo",
      pros: ["30-second checks on every plan", "Alerts only after 2-5 consecutive failed checks", "Flat pricing with a 30-day money-back guarantee"],
      cons: ["Free plan is 5 monitors at 30 s from one location", MONITOR_LOCATIONS.alternativesCon, "No APM or logs"],
      url: "https://uptrack.app",
      isUptrack: true,
    },
    {
      name: "Pulsetic",
      description: "Status pages and uptime monitoring, with status page custom domains on every plan.",
      pricing: "Free (10 monitors), paid plans from Solo",
      pros: ["Status page custom domains on all plans, including free", "Up to 15 check regions on Team", "SMS, call, and WhatsApp alerts billed per message"],
      cons: ["Free plan checks every 5 minutes", "30-second checks start on the Team plan", "Teammates cost $8/mo each"],
      url: "https://pulsetic.com",
    },
    {
      name: "Oh Dear",
      description: "Site health monitoring: uptime, SSL, DNS, broken links, mixed content, Lighthouse, cron, and status pages.",
      pricing: "From $17/mo (2 sites), 10-day trial",
      pros: ["Broken link and mixed content checks", "Application health checks for Laravel/PHP apps", "Unlimited users on all plans"],
      cons: ["No free plan", "1-minute check interval"],
      url: "https://ohdear.app",
    },
    {
      name: "Checkly",
      description: "Monitoring as code with Playwright browser checks, API checks, and CI/CD integration.",
      pricing: "Free (Hobby), Starter $24/mo",
      pros: ["Monitoring as code with Playwright", "CI/CD integration", "Configurable retry strategies"],
      cons: ["API and browser runs above plan limits are billed per run", "30-second checks start on Team ($64/mo)"],
      url: "https://www.checklyhq.com",
    },
  ],
  comparisonTable: [
    { tool: "Better Stack", freePlan: "10 monitors", checkInterval: "3min (free), 30s (paid)", alertConfirmation: "Yes (multi-location)", startingPrice: "$34/mo per responder" },
    { tool: "Uptrack", freePlan: "5 monitors at 30s", checkInterval: "30s (all plans)", alertConfirmation: "Yes (2-5 consecutive)", startingPrice: "Free; Pro $3/mo" },
    { tool: "Pulsetic", freePlan: "10 monitors", checkInterval: "5min (free), 30s (Team)", alertConfirmation: "Not documented", startingPrice: "Solo plan (see site)" },
    { tool: "Oh Dear", freePlan: "None", checkInterval: "1min", alertConfirmation: "Yes (second location)", startingPrice: "$17/mo" },
    { tool: "Checkly", freePlan: "Hobby (10 uptime monitors)", checkInterval: "2min (free), 30s (Team)", alertConfirmation: "Configurable retries", startingPrice: "$24/mo" },
  ],
}

export const Route = createFileRoute('/_site/alternatives/hyperping')({
  component: () => <AlternativesPage data={data} />,
  head: () => alternativesHead(data),
})
